import { useState } from 'react';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { GOLD, fmt, Stat, Field, Card, EntryTable, useEntries } from './shared';

export const EquipmentTab = ({ api, jobId, readOnly }) => {
  const [data, reload] = useEntries(api, `/accounting/jobs/${jobId}/equipment`, jobId);
  const [form, setForm] = useState({ equipment_name: '', rental_or_owned: 'owned', cost: 0, date: '', notes: '' });
  const add = async () => {
    if (!form.equipment_name) return toast.error('Equipment name required');
    try {
      await api.post(`/accounting/jobs/${jobId}/equipment`, { job_id: jobId, ...form });
      setForm({ equipment_name: '', rental_or_owned: 'owned', cost: 0, date: '', notes: '' });
      reload(); toast.success('Equipment added');
    } catch { toast.error('Failed'); }
  };
  if (!jobId) return <p className="text-gray-500">Select a project.</p>;
  return (
    <div data-testid="fos-equipment-tab">
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <Stat label="Total Equipment Cost" value={fmt(data.summary?.total_cost)} accent={GOLD} testid="equipment-total-cost" />
        <Stat label="Entries" value={data.entries?.length || 0} />
      </div>
      {!readOnly && (
        <Card className="mb-6">
          <div className="grid sm:grid-cols-5 gap-3 items-end">
            <Field label="Equipment" type="text" value={form.equipment_name} onChange={(v) => setForm({ ...form, equipment_name: v })} testid="eq-name" />
            <div>
              <label className="text-xs font-medium text-gray-500">Type</label>
              <select data-testid="eq-type" value={form.rental_or_owned} onChange={(e) => setForm({ ...form, rental_or_owned: e.target.value })} className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm">
                <option value="owned">Owned</option>
                <option value="rental">Rental</option>
              </select>
            </div>
            <Field label="Cost" value={form.cost} onChange={(v) => setForm({ ...form, cost: v })} testid="eq-cost" />
            <Field label="Date" type="date" value={form.date} onChange={(v) => setForm({ ...form, date: v })} testid="eq-date" />
            <button data-testid="eq-add-btn" onClick={add} className="h-10 inline-flex items-center justify-center gap-2 px-4 bg-[#C6A87C] text-white text-sm font-medium rounded-lg hover:opacity-90">
              <Plus className="w-4 h-4" /> Add
            </button>
          </div>
        </Card>
      )}
      <EntryTable
        headers={['Date', 'Equipment', 'Type', 'Cost']}
        rows={(data.entries || []).map(e => [e.date, e.equipment_name, e.rental_or_owned, fmt(e.cost)])}
        testid="equipment-table"
      />
    </div>
  );
};
